import * as yup from "yup";

export const validationSchema = yup.object().shape({
  update: yup.boolean(),
  first_name: yup.string().required("First name is required"),
  last_name: yup.string().required("Last name is required"),
  mobile: yup
    .string()
    .min(8)
    .test("", "the mobile number should start with + sign", (value) => {
      if (!value?.startsWith("+")) return false;
      else return true;
    })
    .required("Mobile Number is required field"),
  street: yup.string().required("Street is required"),
  city: yup.string().required("City is required"),
  zip_code: yup.string().required("Zip code is required"),
  country: yup.string().required("Country is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup
    .string()
    .when("update", {
      is: true,
      then: yup.string().min(8, "Password must be at least 8 characters long").required("Password is required"),
      otherwise: yup.string().nullable(),
    }),
  password_confirmation: yup
    .string()
    .when("update", {
      is: true,
      then: yup.string().oneOf([yup.ref("password"), null], "Passwords must match").required("Confirm password is required"),
      otherwise: yup.string().nullable(),
    }),
});
